export type { MissionsGateway, MissionsGatewayFactory, MissionsGatewayMode, MissionStatus, Mission, MissionLead, RepTargets } from './types';
import type { MissionsGatewayFactory } from './types';
import { serviceLayerGateway } from './serviceLayerGateway';

// Factory with lazy imports to prevent circular deps and heavy bundles
export const createMissionsGateway: MissionsGatewayFactory = (_mode) => {
  // Switch to service layer API for missions
  return serviceLayerGateway;
};
